import { capitalizeName, convertSlote, formatDateFunction, checkPermissionAction } from "../../../../../utils/helper/utils";
import SelectRangeModal from "../../../../../Modal/SelectRange";
import { useTranslation } from "../../../../../context/TranslationContext";
import { Button } from "antd";
const DeliveryDetail = ({ orderDetailData, permissionJson, setIsSelectRangeModalOpen, isSelectRangeModalOpen, handleSelectRangeModalOk,
  handleSelectRangeModalCancel, selectedLockerNumber, setselectedLockerNumber, lockerDetails, assignLockerToOrder, setIsChangeAddressModalOpen }) => {
  const { t } = useTranslation();
  const associateBranchId = orderDetailData?.pickupPointDetails ? orderDetailData?.pickupPointDetails?.associateBranchId : 0;
  const branchId = orderDetailData.branchId;
  let driver_pickup_time = 0;
  if (associateBranchId !== branchId) {
    driver_pickup_time =
      orderDetailData?.driver_pickup_time && orderDetailData?.driver_pickup_time !== ""
        ? " " + convertSlote(orderDetailData?.driver_pickup_time)
        : null;
  }

  const hasAddressDetails = Boolean(orderDetailData?.addressDetails?.address);
  const isPickupWithAddressChanged = orderDetailData?.deliveryMode === "pickup" && hasAddressDetails;
  const hiddenChangeAddressStatuses = [ "pickup_delivered", "delivered", "cancelled", "no_show"];
  const isChangeAddressHidden = hiddenChangeAddressStatuses.includes(orderDetailData?.status);

  return (
    <>
      <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <h2 className="font-semibold text-base mb-3">
          {orderDetailData.orderDeliveryType === "qc" || orderDetailData.orderDeliveryType === "qc-payment" ? "Customer" : ""}
          {orderDetailData.orderDeliveryType === "delivery-payment" || orderDetailData.orderDeliveryType === "qc-delivery-payment"
            || orderDetailData.orderDeliveryType === "delivery"
            ? (t("customerAndDeliveryDetails"))
            : ""}
        </h2>
        <div className="flex">
          <img src="images/user-profile.png" alt="user-thumbnail" className="w-[24px] h-[24px] rounded" />
          <div className="pl-2">
            <h3 className="text-sm font-semibold">
              {orderDetailData?.userDetails?.firstName} {orderDetailData?.userDetails?.lastName}
              {orderDetailData?.userDetails?.mobileNo !== "" ? <span className="mx-3">| </span> : null}
              <span className=" font-normal text-[#222222]">
                {orderDetailData?.userDetails?.mobileNo !== "" ? "+966 " + orderDetailData?.userDetails?.mobileNo : null}
              </span>
              <span className="mx-3">| </span>
              {checkPermissionAction("Order Management", permissionJson, "view_otp") && ((orderDetailData.status === "out_for_delivery") || (orderDetailData.status == "pickup_delivered")) ? (
                <>
                  <span
                    type="primary"
                    size={14}
                    className="mx-0 cursor-pointer mr-5"

                  > OTP: {orderDetailData?.otp ? orderDetailData?.otp : "N/A"}
                  </span>
                  <span className="mx-3">| </span>
                </>
              ) : null}
              <span className=" font-normal text-[#222222]">{orderDetailData?.userDetails?.email}</span>
            </h3>
            {orderDetailData?.orderDeliveryType === "delivery-payment" || orderDetailData?.orderDeliveryType === "qc-delivery-payment"
              || orderDetailData.orderDeliveryType === "delivery" ? (
              <>
                {orderDetailData?.deliveryMode !== "" && orderDetailData?.deliveryMode !== "pending" ? (
                  <h3 className="text-sm font-semibold pt-2">
                    {t("deliveryMode")} -
                    {orderDetailData?.orderType === "regular" ? (
                      <span className=" font-normal text-[#222222] mx-2 ">
                        {orderDetailData?.deliveryMode === "delivery" || isPickupWithAddressChanged ? "Home" : capitalizeName(orderDetailData?.deliveryMode)}
                      </span>
                    ) : null}
                    {orderDetailData?.orderType === "custom_cake" ? (
                      <span className=" font-normal text-[#222222] mx-2 ">
                        {orderDetailData?.deliveryMode === "delivery" || isPickupWithAddressChanged ? "Home" : capitalizeName(orderDetailData?.deliveryMode)}
                      </span>
                    ) : null}
                    {orderDetailData?.orderType === "gift" ? <span className=" font-normal text-[#222222] mx-2 ">Gift</span> : null}
                  </h3>
                ) : null}
                {orderDetailData?.giftDetails ? (
                  <h3 className="text-sm font-semibold pt-2">
                    {t("recipientDetail")} :
                    <span className=" font-normal text-[#222222] mx-2 ">
                      {capitalizeName(orderDetailData?.giftDetails?.recipient_name)} | {orderDetailData?.giftDetails?.mobile_no}
                    </span>
                  </h3>
                ) : null}
                <div className="flex flex-wrap items-center gap-2">
                <a
                  href="#"
                  style={{ fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={(e) => {
                    e.preventDefault();
                    const useCustomerAddress = orderDetailData?.deliveryMode !== 'pickup' || hasAddressDetails;
                    const latitude = useCustomerAddress
                      ? orderDetailData?.addressDetails?.lat : orderDetailData?.pickupPointDetails?.latitude;

                    const longitude = useCustomerAddress
                      ? orderDetailData?.addressDetails?.lng : orderDetailData?.pickupPointDetails?.longitude;

                    if (latitude && longitude) {
                      const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
                      window.open(mapUrl, '_blank');
                    }
                  }}
                >
                  {orderDetailData?.deliveryMode === "pickup" && !hasAddressDetails ? (
                    <p className="text-sm pt-[4px] text-[#3553e6]">
                      {orderDetailData?.pickupPointDetails?.address} |{" "}
                      <strong>
                        {orderDetailData?.pickupPointDetails?.dropZoneLocales?.find((locale) => locale.languageCode === "en")?.name}
                      </strong>
                    </p>
                  ) : orderDetailData?.addressDetails?.address ? (
                    <span className="text-sm pt-[4px] text-[#3553e6]">
                      {(() => {
                        const { buildingNumber, floorApartment, address } = orderDetailData.addressDetails;
                        const parts = [];
                        if (buildingNumber) parts.push(`Building no. ${buildingNumber}`);
                        if (floorApartment) parts.push(floorApartment);
                        if (address) parts.push(address);
                        return parts.join(", ");
                      })()}
                    </span>
                  ) : null}
                </a>
                  {(orderDetailData?.deliveryMode === "delivery" || orderDetailData?.deliveryMode === "pickup") && !isChangeAddressHidden && checkPermissionAction("Order Management", permissionJson, "change_address") && (
                    <Button size="small" type="primary" onClick={() => setIsChangeAddressModalOpen(true)}>
                      {t("changeAddress")}
                    </Button>
                  )}
                </div>
                {/* The Scheduled Date  below will change when the end status is updated */}
                {
                  <p className=" text-sm pt-[4px] text-[#222222] font-medium">
                    {t("deliveryType")} - {capitalizeName(orderDetailData?.deliveryType)}{" "}
                    {/* {orderDetailData?.deliveryType === "fastest" ? (
                      <small>(ASAP)</small>
                    ) : null}{" "} */}
                    {orderDetailData?.deliveryDate ? formatDateFunction(orderDetailData?.deliveryDate, "dd/mm/yyyy") : null}
                    {driver_pickup_time !== 0 ? driver_pickup_time : ""}
                    {orderDetailData?.timeSlotDetails && orderDetailData?.deliveryType === "scheduled" && Object.keys(orderDetailData.timeSlotDetails).length > 0
                      ? ", " +
                      (convertSlote(orderDetailData?.timeSlotDetails.openTime) +
                        " - " +
                        convertSlote(orderDetailData?.timeSlotDetails.closeTime))
                      : null}
                    {orderDetailData?.timeSlotDetails && orderDetailData?.deliveryType !== "scheduled" && Object.keys(orderDetailData.timeSlotDetails).length > 0
                      ? ", " +
                      orderDetailData?.timeSlotDetails.openTime +
                      " - " +
                      orderDetailData?.timeSlotDetails.closeTime
                      : null}
                  </p>
                }
                {orderDetailData?.status === "pickup_delivered" && orderDetailData?.assignedLocker ?
                  <p className=" text-sm pt-[4px] text-[#222222] font-medium">
                    {t("assignedLocker")} - {orderDetailData?.assignedLocker}
                  </p> : null}
                {(checkPermissionAction("Order Management", permissionJson, "assign_locker") && orderDetailData?.status === "pickup_delivered" && orderDetailData?.pickupPointDetails?.deviceCode) &&
                  <h2 className="underline text-base  cursor-pointer" onClick={() => setIsSelectRangeModalOpen(true)}>
                    {orderDetailData?.assignedLocker ? "Reassign Locker" : "Assign Locker"}
                  </h2>}
                {orderDetailData?.status !== "placed" && orderDetailData?.status !== "confirmed" && driver_pickup_time !== 0 ? (
                  <p className=" text-sm pt-[4px] text-[#222222] font-medium">
                    {t("deliveryPickupTime")} -{" "}
                    {orderDetailData?.deliveryDate ? formatDateFunction(orderDetailData?.deliveryDate, "dd/mm/yyyy") : null}
                    {/* {orderDetailData?.deliveryType === "fastest"
                      ? " (ASAP)"
                      : `at ${convertSlote(
                          orderDetailData?.driver_pickup_time
                        )}`} */}
                    {driver_pickup_time !== 0 ? ` at ${driver_pickup_time}` : ""}
                  </p>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>
      {
        isSelectRangeModalOpen &&
        <SelectRangeModal
          isOpen={isSelectRangeModalOpen}
          onOk={handleSelectRangeModalOk}
          onCancel={handleSelectRangeModalCancel}
          selectedLockerNumber={selectedLockerNumber}
          setselectedLockerNumber={setselectedLockerNumber}
          lockerDetails={lockerDetails}
          assignLockerToOrder={assignLockerToOrder}
          orderId={orderDetailData?.id}
          assignedLocker={orderDetailData?.assignedLocker}
        />
      }
    </>
  );
};
export default DeliveryDetail;
